import { Component } from '@angular/core';

import { AuthenticationService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

    token: any;
    
    constructor(
        private authenticationService: AuthenticationService
    ) {
        console.clear();
     }
    
    ngOnInit() {
        this.authenticationService.getUserName().subscribe(message => { this.token = message; });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/app.component.ts